import React from "react";
import {
    Box,
    Typography,
    Chip,
} from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";

import default_theme from "assets/themes/themes";

const isRecentPublishedAt = (publishedAt) => {
    if (!publishedAt) return false;

    const publishedDate = new Date(publishedAt);
    if (Number.isNaN(publishedDate.getTime())) return false;

    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);

    return publishedDate >= twoMonthsAgo;
};

const SolutionDetailHeader = ({
    data,
    styles,
    extraChips = [],
}) => {
    const showNewTag = isRecentPublishedAt(data?.published_at);
    return (
        <Box className={styles.headerSection}>

            <Typography variant="h3" className={styles.mainTitle}>
                {data.title_english || data.title || "Untitled Solution"}
            </Typography>

            {data.title && data.title !== data.title_english && (
                <Typography variant="h5" className={styles.localTitle}>
                    {data.title}
                </Typography>
            )}

            <Box className={styles.chipContainer}>
                {showNewTag && (
                    <Chip
                        label="NEW"
                        className={styles.infoChip}
                        sx={{
                            fontWeight: 800,
                            color: default_theme.palette.primary.main,
                            backgroundColor: default_theme.palette.other.chatGreen,
                        }}
                    />
                )}

                {/* NEW STATUS CHIP */}
                {data.status && (
                    <Chip
                        label={data.status}
                        className={styles.infoChip}
                        sx={{
                            backgroundColor: "#d60c0c",
                            border: "1px solid #D0D5DD",
                            color: "#f7f3f5",
                            fontWeight: 600,
                        }}
                    />
                )}

                {data.location_country && (
                    <Chip
                        icon={<LocationOnIcon />}
                        label={data.location_country}
                        className={styles.infoChip}
                        sx={{
                            backgroundColor:
                                default_theme.palette.other.lightBlue,
                        }}
                    />
                )}

                {data.lead_org_name && (
                    <Chip
                        icon={<BusinessIcon />}
                        label={data.lead_org_name}
                        className={styles.infoChip}
                        sx={{
                            backgroundColor:
                                default_theme.palette.other.lightPurple,
                        }}
                    />
                )}

                {data.rdd_1 && (
                    <Chip
                        label={data.rdd_1}
                        className={styles.infoChip}
                        sx={{
                            backgroundColor:
                                default_theme.palette.other.paleGreen,
                        }}
                    />
                )}

                {extraChips.map((chip, index) => (
                    <Chip
                        key={`${chip.label}-${index}`}
                        {...chip}
                        className={styles.infoChip}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default SolutionDetailHeader;